/**
 * Slideshow Video Control
 * Ensures only one video plays at a time in slideshow
 */

if (!customElements.get('slideshow-component')) {
  console.error('slideshow-component not found');
} else {
  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    
    // Find all slideshow components
    const slideshows = document.querySelectorAll('slideshow-component');
    
    slideshows.forEach(slideshow => {
      
      // Pause all videos on initialization
      function pauseAllVideos() {
        const allVideoElements = slideshow.querySelectorAll('video-element');
        allVideoElements.forEach(videoEl => {
          // Find actual video tag
          const videoTag = videoEl.querySelector('video');
          if (videoTag) {
            videoTag.pause();
            videoTag.currentTime = 0;
          }
          // Also pause through video-element API if available
          if (typeof videoEl.pause === 'function') {
            videoEl.pause();
          }
        });
      }
      
      // Play only active slide's video
      function playActiveVideo() {
        const activeSlide = slideshow.querySelector('.swiper-slide-active');
        if (activeSlide && activeSlide.dataset.type === 'video') {
          const videoElement = activeSlide.querySelector('video-element');
          if (videoElement) {
            // Small delay to ensure element is ready
            setTimeout(() => {
              if (typeof videoElement.play === 'function') {
                videoElement.play();
              }
            }, 100);
          }
        }
      }
      
      // Initial setup - pause all, play active
      setTimeout(() => {
        pauseAllVideos();
        playActiveVideo();
      }, 500);
      
      // Watch for slide changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const slide = mutation.target;
            if (slide.classList.contains('swiper-slide')) {
              if (slide.classList.contains('swiper-slide-active')) {
                // This slide became active
                pauseAllVideos();
                playActiveVideo();
              }
            }
          }
        });
      });
      
      // Observe all slides
      const slides = slideshow.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
      
      // Also listen to swiper events if available
      if (slideshow.sliderInstance && slideshow.sliderInstance.slider) {
        slideshow.sliderInstance.slider.on('slideChange', () => {
          pauseAllVideos();
          setTimeout(playActiveVideo, 100);
        });
      }
      
    });
    
  });
}

